
import { Download } from "@mui/icons-material";
import { useGeneralAppStore } from "../../store/generalAppStore";
import { useRifaStore } from "../../store/rifaStore";
import Modal from "../Modal";
import ModalCustom from "../ModalCustom";
import useWindowSize from "../../hooks/sizeWindow";

const ModalPdf = () => {

    const { modals, handlerModal } = useGeneralAppStore()
    const { solicitud } = useRifaStore();
    const size = useWindowSize();

    return (
        <>
            <ModalCustom
                show={modals.includes('descarga_pdf')}
                size={"fullscreen"}
                onHide={() => handlerModal({ modal: false, modalName: "descarga_pdf" })}
                title={() => "Recibo de rifa"}
            >
                <> 
                    <div className="d-flex flex-column gap-2">
                        {
                            size.width > 360 &&
                            <a
                                href={solicitud?.pdf_recibo}
                                download={`Recibo-Rifa-${solicitud.solicitud.nombre_completo}`}
                                className="text-center mb-3  d-block  bg-success text-light px-3 py-1 rounded mx-auto"
                                style={{ border: "2px #FFF ", right: "0", top: "-50px", textDecoration: "none", fontSize: "13px", width: "fit-content", }}
                            >
                                <Download />
                                DESCARGAR RECIBO
                            </a>
                        }
                        <div style={{ width: "100%", height: "80vh" }}>
                            <object type="application/pdf" data={solicitud?.pdf_recibo} height={"100%"} width={"100%"} />
                        </div>



                        {/* <div style={{ width:"80%" }} className=" overflow-hidden mx-auto border border-1 border-secondary   ">
                        <img src={solicitud.imgPreview}  className="w-100 h-100 object-fit-contain"></img>
                    </div> */}
                    </div>
                </>
            </ModalCustom>
        </>
    );
}
export default ModalPdf;